import { ILoteSolicitadoRepository } from '../repositories/ILoteSolicitadoRepository'

export interface IEndTrip {
  execute(loteId: number): Promise<void>
}

export default class IEndTripImpl implements IEndTrip {
  constructor(
    private readonly loteSolicitadoRepository: ILoteSolicitadoRepository,
  ) {}

  public async execute(loteId: number): Promise<void> {
    await this.loteSolicitadoRepository.endTrip(loteId)
  }
}
